<template>
	<TemplateHeroDiagonal v-bind="props">
		<slot />
	</TemplateHeroDiagonal>
</template>

<script lang="ts" setup>
import type { BreadcrumbsType } from '#base/core/types/BreadcrumbsType';
import type { VideoType } from '#base/core/types/VideoType';

const props = defineProps<{
	backgroundVideo?: VideoType;
	pageTitle: string;
	pageTitlePrefix?: string;
	pageTitleSuffix?: string;
	breadcrumbs?: BreadcrumbsType;
	isSales?: boolean;
}>();
</script>
